import {
  AddressRequestV1,
  AddressResponseV1 as PickupDeliveryLocationAddressResponseV1,
  PickupDeliveryLocationCreateRequestV1,
  PickupDeliveryLocationResponseV1,
  PickupDeliveryLocationUpdateRequestV1,
} from '@forto-dev/customer-master-data-models'

import { AddressData, AddressFormData } from '../components/AddressSelector/schema'
import { LocationFormData } from '../schema'

const mapAddressFormToAddressRequest = (address: AddressData | undefined): AddressRequestV1 => {
  return {
    countryCode: address?.countryCode,
    locationRef: address?.locationRef ?? undefined,
    locality1: address?.locality1 ? address?.locality1 : undefined,
    locality2: address?.locality2 ? address?.locality2 : undefined,
    locality3: address?.locality3 ? address?.locality3 : undefined,
    region1: address?.region1 ? address?.region1 : undefined,
    region2: address?.region2 ? address?.region2 : undefined,
    region3: address?.region3 ? address?.region3 : undefined,
    region4: address?.region4 ? address?.region4 : undefined,
    route1: address?.route1 ? address?.route1 : undefined,
    route2: address?.route2 ? address?.route2 : undefined,
    postalCode: address?.postalCode ? address?.postalCode : undefined,
    additionalInformation: address?.additionalInformation ? address?.additionalInformation : undefined,
  }
}

export const mapLocationFormToPickupDeliveryLocationCreateRequest = (
  accountID: string,
  formData: LocationFormData,
  organizationID?: string
): PickupDeliveryLocationCreateRequestV1 => {
  return {
    accountID,
    address: {
      ...mapAddressFormToAddressRequest(formData.address?.address),
      companyName: formData.companyName ? formData.companyName : undefined,
    },
    localAddress: formData.address?.localAddress
      ? mapAddressFormToAddressRequest(formData.address?.localAddress)
      : undefined,
    locationName: formData.locationName,
    notes: formData.notes ? formData.notes : undefined,
    unLocode: formData.unLocode ? formData.unLocode : undefined,
    contactIDs: formData.contact,
    organizationID: organizationID,
  }
}

export const mapLocationFormToPickupDeliveryLocationUpdateRequest = (
  accountID: string,
  formData: LocationFormData,
  pickupDeliveryLocation: PickupDeliveryLocationResponseV1
): PickupDeliveryLocationUpdateRequestV1 => {
  return {
    accountID,
    address: {
      ...mapAddressFormToAddressRequest(formData.address?.address),
      companyName: formData.companyName ? formData.companyName : undefined,
    },
    locationName: formData.locationName,
    notes: formData.notes ? formData.notes : null,
    unLocode: formData.unLocode ? formData.unLocode : null,
    contactIDs: formData.contact ?? [],
    localAddress: formData.address?.localAddress
      ? mapAddressFormToAddressRequest(formData.address?.localAddress)
      : null,
    legalEntityIDs: pickupDeliveryLocation.legalEntityIDs,
    organizationID: pickupDeliveryLocation.organizationID,
    references: pickupDeliveryLocation.references,
  }
}

const mapPickupDeliveryLocationAddressResponseToAddress = (
  address: PickupDeliveryLocationAddressResponseV1
): AddressData => {
  return {
    companyName: address.companyName ?? undefined,
    route1: address.route1 ?? undefined,
    route2: address.route2 ?? undefined,
    route3: address.route3 ?? undefined,
    route4: address.route4 ?? undefined,
    additionalInformation: address.additionalInformation ?? undefined,
    locality1: address.locality1 ?? undefined,
    locality2: address.locality2 ?? undefined,
    locality3: address.locality3 ?? undefined,
    locality4: address.locality4 ?? undefined,
    region1: address.region1 ?? undefined,
    region2: address.region2 ?? undefined,
    region3: address.region3 ?? undefined,
    region4: address.region4 ?? undefined,
    postalCode: address.postalCode ?? undefined,
    countryCode: address.countryCode ?? undefined,
    locationRef: address.locationRef ?? undefined,
    source: address.source ?? undefined,
  }
}

export const mapPickupDeliveryLocationResponseToAddressFormData = (
  location: PickupDeliveryLocationResponseV1
): AddressFormData => {
  return {
    address: mapPickupDeliveryLocationAddressResponseToAddress(location.address),
    addressFormatted: location.addressFormatted,
    localAddress: location.localAddress
      ? mapPickupDeliveryLocationAddressResponseToAddress(location.localAddress)
      : null,
    localAddressFormatted: location.localAddressFormatted,
  }
}
